import { z } from 'zod';
import {
  calendarSubscriptionSchema,
  syncCalendarSubscriptionResponseSchema,
  type CalendarSubscription,
  type CreateCalendarSubscriptionRequest,
  type SyncCalendarSubscriptionResponse,
  type UpdateCalendarSubscriptionRequest,
} from '@mrrmlab/shared-types';
import type { HttpClient } from './http';

const subscriptionListSchema = z.array(calendarSubscriptionSchema);

export class CalendarResource {
  constructor(private readonly http: HttpClient) {}

  listSubscriptions(signal?: AbortSignal): Promise<CalendarSubscription[]> {
    return this.http.request({
      method: 'GET',
      path: '/calendar/subscriptions',
      responseSchema: subscriptionListSchema,
      signal,
    });
  }

  createSubscription(
    body: CreateCalendarSubscriptionRequest,
    signal?: AbortSignal,
  ): Promise<CalendarSubscription> {
    return this.http.request({
      method: 'POST',
      path: '/calendar/subscriptions',
      body,
      responseSchema: calendarSubscriptionSchema,
      signal,
    });
  }

  updateSubscription(
    id: string,
    body: UpdateCalendarSubscriptionRequest,
    signal?: AbortSignal,
  ): Promise<CalendarSubscription> {
    return this.http.request({
      method: 'PATCH',
      path: `/calendar/subscriptions/${id}`,
      body,
      responseSchema: calendarSubscriptionSchema,
      signal,
    });
  }

  deleteSubscription(id: string, signal?: AbortSignal): Promise<void> {
    return this.http.request({
      method: 'DELETE',
      path: `/calendar/subscriptions/${id}`,
      expectEmpty: true,
      signal,
    });
  }

  syncSubscription(
    id: string,
    signal?: AbortSignal,
  ): Promise<SyncCalendarSubscriptionResponse> {
    return this.http.request({
      method: 'POST',
      path: `/calendar/subscriptions/${id}/sync`,
      responseSchema: syncCalendarSubscriptionResponseSchema,
      signal,
    });
  }
}
